module.exports = __webpack_public_path__ + "static/media/how_to_drink_herb_tea.8c820dc7.jpg";